import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './resources/en/common.json';
import idCommon from './resources/id/common.json';
import enGuest from './resources/en/guest.json';
import idGuest from './resources/id/guest.json';
import enJobs from './resources/en/jobs.json';
import idJobs from './resources/id/jobs.json';
import enAssets from './resources/en/assets.json';
import idAssets from './resources/id/assets.json';
import enDashboard from './resources/en/dashboard.json';
import idDashboard from './resources/id/dashboard.json';
import enMasterdata from './resources/en/masterdata.json';
import idMasterdata from './resources/id/masterdata.json';
import enProfile from './resources/en/profile.json';
import idProfile from './resources/id/profile.json';
import enAdmin from './resources/en/admin.json';
import idAdmin from './resources/id/admin.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        guest: enGuest,
        jobs: enJobs,
        assets: enAssets,
        dashboard: enDashboard,
        masterdata: enMasterdata,
        profile: enProfile,
        admin: enAdmin,
      },
      id: {
        common: idCommon,
        guest: idGuest,
        jobs: idJobs,
        assets: idAssets,
        dashboard: idDashboard,
        masterdata: idMasterdata,
        profile: idProfile,
        admin: idAdmin,
      },
    },
    fallbackLng: 'en',
    ns: ['common', 'guest', 'jobs', 'assets', 'dashboard', 'masterdata', 'profile', 'admin'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
